export default {
  jpeg: 'image/jpeg',
  jpg: 'image/jpg',
  png: 'image/png',
};
